import './scss/main.scss';

import * as bootstrap from 'bootstrap';

function execute() {
    /**
     * Collapse navbar on mobile after navigating to section
     */
    const bsCollapse = new bootstrap.Collapse('#navbarNav', {
        toggle: false
    });
    const navBarToggler = document.querySelector(".navbar-toggler");
    const navLinks = document.querySelectorAll(".nav-link");

    navLinks.forEach((navLink) => {
        navLink.addEventListener("click", function () {
            if (!navBarToggler.classList.contains("collapsed")) {
                bsCollapse.toggle();
            }
        });
    });

    /**
     * e-link and e-href processing
     */
    const x = "bWFpbHRvOnZhbGVudGluYS5jYXRhbmFAZ21haWwuY29t";
    const eLinks = document.querySelectorAll(".e-link");
    const eHrefs = document.querySelectorAll(".e-href");
    eLinks.forEach(function (a) {
        a.setAttribute("href", atob(x));
        a.textContent = atob(x).substring(7);
    });
    eHrefs.forEach(function (a) {
        a.setAttribute("href", atob(x));
    });
}

if (document.readyState === "loading") {
    // Loading hasn't finished yet
    document.addEventListener("DOMContentLoaded", execute);
} else {
    // `DOMContentLoaded` has already fired
    execute();
}
